// About.js
import React from 'react';
import styled from '@xstyled/styled-components';

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.6);
  z-index: 1000;
  display: ${({ show }) => (show ? 'flex' : 'none')};
  align-items: center;
  justify-content: center;
`;

const Modal = styled.div`
  background: white;
  padding: 20px;
  max-width: 90%;
  width: 400px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.2);
`;

const CloseButton = styled.button`
  float: right;
  background: none;
  border: none;
  font-size: 1.2rem;
  cursor: pointer;
`;

const AboutModal = ({ show, onClose }) => {
  return (
    <Overlay show={show}>
      <Modal>
        <CloseButton onClick={onClose}>&times;</CloseButton>
        <h2>About</h2>
        <>
          <p>
            <strong>AI Consultant</strong> helps you explore ideas from multiple perspectives by simulating conversations with configurable AI "consultants."
          </p>
          <p>
            You can fully customize each consultant:
          </p>
          <ul>
            <li>Edit their <strong>instructions</strong> (system + assistant messages) to control tone, style, and expertise.</li>
            <li><strong>Add</strong> or <strong>remove</strong> consultants as your needs evolve.</li>
            <li>Use the built-in <strong>Summarizer</strong> agent to pull together advice from multiple consultants into a clear, concise summary.</li>
          </ul>
          <p>
            For each conversation:
          </p>
          <ul>
            <li>You can selectively <strong>include responses</strong> in future prompts by checking the box in the top-right corner of the response.</li>
            <li>This allows you to guide each consultant with only the insights you value.</li>
          </ul>
          <p>
            Built with <strong>React</strong>, <strong>Azure Functions</strong>, and a bit of magic.
            <br />
            Designed for flexibility, insight, and creativity.
          </p>
        </>

      </Modal>
    </Overlay>
  );
};

export default AboutModal;
